<template>
<div>
    <Breadcrumbs main="Admin" submain="Resources" title="Asset Edit" />

    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-8">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Asset Name</label>
                                        <input class="form-control" type="text" placeholder="Enter asset name" v-model="temp_asset.name">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Type</label>
                                        <select class="form-control digits" v-model="temp_asset.asset_type">
                                            <option v-for="(type, index) in type" :key="index" :value="type.id">{{ type.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Amount</label>
                                        <input class="form-control" type="number" placeholder="Enter asset amount" v-model="temp_asset.amount">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Status</label>
                                        <select class="form-control digits" v-model="temp_asset.status">
                                            <option v-for="(status, index) in statuses" :key="index">{{ status }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Camp</label>
                                        <select class="form-control digits" v-model="temp_asset.location" @change="getBlocksByCamp(temp_asset.location)">
                                            <option selected disabled>Select a camp</option>
                                            <option v-for="(loc, index) in locations" :key="index" :value="loc.id">{{ loc.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Block</label>
                                        <select class="form-control digits" v-model="temp_asset.block">
                                            <option selected disabled>Select a block</option>
                                            <option v-for="(block, index) in blocks" :key="index" :value="block.id">{{ block.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Address Line</label>
                                        <input class="form-control" type="text" placeholder="Enter address line" v-model="temp_asset.address_line">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Purchase Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="temp_asset.purchase_date"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Manufacture Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="temp_asset.manufacture_date"></datepicker>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Warranty End</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="temp_asset.warranty_end"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Items</label>
                                        <ItemTable v-if="temp_asset.specification" id="item-table" style="margin-bottom: 10px;" :tableData="parsedSpecification" @itemsUpdated="updateItems" />
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Asset Photo</label>
                                        <div class="flex items-center">
                                            <img v-if="show_image" style="height: 80px; width: 80px; object-fit: cover;" :src="show_image">
                                            <input :class="show_image ? 'ml-4' : 'ml-0'" type="file" accept="image/*" @change="uploadFile">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-1">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Asset Details</label>
                                        <b-form-textarea id="textarea-auto-height" placeholder="Enter asset details..." v-model="temp_asset.details" rows="4" max-rows="12"></b-form-textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="onSubmit()" class="btn btn-success mr-3">Submit</button>
                                        <router-link to="/resources/asset/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>

            <div class="col-sm-4">
                <px-card>
                    <div class="w-100 p-3">
                        <div class="d-flex justify-content-between">
                            <h6 class="mb-3">Supporting Documents</h6>
                            <feather type="plus-square" size="22px" style="color: #ff595d; cursor: pointer;" v-b-modal.modal-scrollable-add-document v-b-tooltip.hover title="Add Documents"> </feather>
                        </div>

                        <div>
                            <b-table show-empty sticky-header :items="asset.asset_attach" :fields="Attachment" head-variant="light">
                                <template #cell(index)="data">
                                    {{ data.index + 1 }}
                                </template>

                                <template #cell(title)="data">
                                    <a :href="host+data.item.asset_attachment" target="_blank">{{ truncateText(data.item.attach_title, 100) }}</a>
                                </template>

                                <template #cell(action)="data">
                                    <div style="display: flex; flex-direction: row; gap:10px">
                                        <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover title="Delete" @click="deleteAttach(data.item.id)"></feather>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>

    <!-- Project Attachment Create -->
    <b-modal id="modal-scrollable-add-document" ref="modal" title="Add document" @ok="handleAttachOk">
        <form ref="form" @submit.stop.prevent="handleAttahmentSubmit">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Upload Documents</label>
                        <b-form-file placeholder="Choose files  or drop them here..." drop-placeholder="Drop file here..." @change="uploadAttachFile"></b-form-file>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {
    myHost
} from '../../../_helpers/host';
import {
    mapState
} from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";
import ItemTable from "./edit-item-table.vue";

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable
    },

    data() {
        return {
            host: myHost.host,
            add_attachment: {
                asset_attachment: null,
                asset_id: '',
            },
            temp_asset: {
                name: '',
                status: null,
                image: null,
                asset_type: null,
                location: null,
                block: null,
                address_line: '',
                warranty_end: null,
                details: '',
                specification: [],
                amount: null,
                purchase_date: null,
                manufacture_date: null
            },
            Attachment: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: true
                }
            ],
            show_image: null,
            statuses: ['ACTIVE', 'UNDER MAINTENANCE', 'APPROVAL PENDING', 'INACTIVE'],
        };
    },
    computed: {
        ...mapState({
            asset: state => state.asset.assetDetail,
            type: state => state.asset.assetType,
            locations: state => state.camp.camp,
            blocks: state => state.block.block
        }),
        parsedSpecification() {
            if (!this.temp_asset.specification) return [];
            if (Array.isArray(this.temp_asset.specification)) return this.temp_asset.specification;
            try {
                return JSON.parse(this.temp_asset.specification);
            } catch (e) {
                return [];
            }
        }
    },

    mounted() {
        this.$store.dispatch('asset/fetchAssetDetails', this.$route.params.id)
        this.$store.dispatch("asset/fetchType")
        this.$store.dispatch("camp/fetchCamp")
        this.$store.dispatch("block/fetchBlock")
    },

    watch: {
        asset(oldValue, newValue) {
            this.temp_asset.name = this.asset.name ? this.asset.name : null
            this.temp_asset.asset_type = this.asset.asset_type ? this.asset.asset_type : null
            this.temp_asset.amount = this.asset.amount ? this.asset.amount : null
            this.temp_asset.status = this.asset.status ? this.asset.status : null
            this.temp_asset.location = this.asset.location ? this.asset.location : null
            this.temp_asset.block = this.asset.block ? this.asset.block : null
            this.temp_asset.address_line = this.asset.address_line ? this.asset.address_line : null
            this.temp_asset.purchase_date = this.asset.purchase_date ? this.asset.purchase_date : null
            this.temp_asset.manufacture_date = this.asset.manufacture_date ? this.asset.manufacture_date : null
            this.temp_asset.warranty_end = this.asset.warranty_end ? this.asset.warranty_end : null
            this.temp_asset.details = this.asset.details ? this.asset.details : null
            this.temp_asset.specification = this.asset.specification ? JSON.parse(this.asset.specification) : []
            this.show_image = this.host + this.asset.image
        }
    },

    methods: {
        getBlocksByCamp(camp_id) {
            this.$store.dispatch("block/getBlocksByCamp", camp_id)
        },

        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        updateItems(data) {
            console.log(data)
            if (data) {
                this.temp_asset.specification = JSON.stringify(data);
            }
        },

        handleAttachOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleAttahmentSubmit()
        },

        handleAttahmentSubmit() {
            this.add_attachment.asset_id = this.$route.params.id
            this.$store.dispatch("asset/addAssetAttachment", {
                attachment: this.add_attachment,
                asset_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.add_attachment.requisition_attachment = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-scrollable-add-document')
            })
        },

        deleteAttach(id) {
            this.$store.dispatch("asset/deleteAttachmentFromAsset", {
                id: id,
                asset_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        uploadAttachFile(e) {
            this.add_attachment.asset_attachment = e.target.files[0]
        },

        uploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.temp_asset.image = e.target.result;
                this.show_image = e.target.result;
            };
        },

        onSubmit() {
            if (this.temp_asset.warranty_end !== null) {
                this.temp_asset.warranty_end = moment(String(this.temp_asset.warranty_end)).format("YYYY-MM-DD");
            }
            if (this.temp_asset.manufacture_date !== null) {
                this.temp_asset.manufacture_date = moment(String(this.temp_asset.manufacture_date)).format("YYYY-MM-DD");
            }
            if (this.temp_asset.purchase_date !== null) {
                this.temp_asset.purchase_date = moment(String(this.temp_asset.purchase_date)).format("YYYY-MM-DD");
            }
            this.temp_asset.name = this.temp_asset.name.trim() ? this.temp_asset.name : null;

            this.$store.dispatch("asset/updateAsset", {
                id: this.$route.params.id,
                payload: this.temp_asset
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.temp_asset.name = null
                    this.temp_asset.status = null
                    this.temp_asset.image = null
                    this.temp_asset.asset_type = null
                    this.temp_asset.location = null
                    this.temp_asset.block = null
                    this.temp_asset.address_line = null
                    this.temp_asset.warranty_end = null
                    this.temp_asset.details = null
                    this.temp_asset.specification = []
                    this.temp_asset.amount = null
                    this.temp_asset.purchase_date = null
                    this.temp_asset.manufacture_date = null
                    setTimeout(() => {
                        this.$router.push('/resources/asset/list')
                    }, 2000)
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

        }
    }
};
</script>

<style scoped>
.content-container-attahment {
    background-color: white;
    padding: 10px;
}
</style>
